import { Info } from "lucide-react";

import { cn } from "src/lib/utils";

export const AssistantDisclosureNotice = ({ className }) => (
  <div
    className={cn(
      "text-muted-foreground flex items-start gap-2 text-xs",
      className
    )}
  >
    <p className="min-h-4">
      <Info className="size-4 pr-1 inline align-text-bottom" />
      AI can make mistakes. Use it as guidance, not a final decision.
    </p>
  </div>
);
